<template>
  <div class="countdown d-inline grey--text text--darken-3">
    <!-- <v-icon>mdi-clock-outline</v-icon> -->
    <span v-if="showCaption" class="text-uppercase mr-4"
      >Due Date and Time:
    </span>
    <span class="mr-2 grey--text text--darken-3" v-if="showDate">{{
      date
    }}</span>
    <!-- ({{ hours | two_digits }} hrs and {{ minutes | two_digits }} mins) -->
    <!-- {{ time }} -->
    <div
      v-if="currentStatus == 'green lighten-4'"
      class="d-inline ml-2 body-2 green--text"
    >
      (Completed)
    </div>
    <div v-else-if="min >= 0 && hour >= 0" class="d-inline">
      (
      <div class="d-inline" v-if="hour > 0">
        {{ hour }} {{ hour > 1 ? " hours and " : " hour and " }}
      </div>
      <div class="d-inline" v-if="hour <= 8 && currentStatus == 'yellow'">
        {{ hour }} {{ hour > 1 ? " hours and " : " hour and " }}
      </div>
      <div class="d-inline">
        {{ min }} {{ min > 1 ? " minutes" : "minute" }} remaining
      </div>
      )
    </div>
    <div v-else class="d-inline ml-2 body-2 red--text">(Overdue)</div>
    <!-- ({{ sec >= 0 ? min + ' minutes and ' + sec + ' seconds' : 'Overdue'}}) -->
    <!-- ({{ min }} minutes and {{ sec }} seconds) -->
    <!-- <div class="block">
      <p class="digit"></p>
      <p class="text">Minutes</p>
    </div> -->
    <!-- <div class="block">
      <p class="digit">{{ seconds | two_digits }}</p>
      <p class="text">Seconds</p>
    </div> -->
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import moment from "moment";

  export default {
    name: "DateCountdown",
    // mounted() {
    //   window.setInterval(() => {
    //     this.now = Math.trunc(new Date().getTime() / 1000);
    //   }, 1000);
    // },
    mounted: function() {
      setInterval(() => {
        // this.dateNow = moment(this.dateNow.subtract(1, 'seconds'))
        this.currentTime = moment();
        this.duration = moment.duration(this.eventTime.diff(this.currentTime));
      }, 1000);
    },
    props: {
      date: {
        type: String,
      },
      currentStatus: String,
      showCaption: Boolean,
      showDate: Boolean,
      colorList: Array,
      routeId: Number,
      routeType: String,
      accessRoutesList: String,
      isWarned: Boolean,
      isOverdued: Boolean,
      onlyHeader: Boolean,
      subRouteIndex: Number,
      parentRouteId: String,
    },
    data() {
      return {
        now: Math.trunc(new Date().getTime() / 1000),
        called_once: false,
        dateNow: moment(this.date),
        eventTime: moment(this.date),
        currentTime: moment(),
        duration: null,
      };
    },
    methods: mapActions([
      "warnRouteStatus",
      "setRouteOverdue",
      "setSubRouteOverdue",
      "warnSubRouteStatus",
    ]),
    computed: {
      dateInMilliseconds() {
        const miliSec = Math.trunc(Date.parse(this.date) / 1000);
        // console.log(miliSec);
        return miliSec;
      },
      hour: function() {
        let hours = this.duration.days() * 24 + this.duration.hours();
        let minutes = this.duration.minutes();

        if (!this.isWarned && !this.onlyHeader) {
          if (hours < 8) {
            if (minutes >= 0) {
              if (this.routeType != "subroute") {
                this.warnRouteStatus({
                  route_id: this.routeId,
                  type: this.routeType,
                  listAccess: this.accessRoutesList,
                });
              } else {
                this.warnSubRouteStatus({
                  route_id: this.routeId,
                  type: this.routeType,
                  listAccess: this.accessRoutesList,
                  route_index: this.subRouteIndex,
                  container: this.parentRouteId,
                });
              }
            }
          }
        }

        return hours;
      },
      min: function() {
        let minutes = this.duration.minutes();

        if (this.isOverdued != true) {
          if (minutes < 0) {
            if (this.routeType != "subroute") {
              this.setRouteOverdue({
                route_id: this.routeId,
                type: this.routeType,
                listAccess: this.accessRoutesList,
              });
            } else {
              this.setSubRouteOverdue({
                route_id: this.routeId,
                type: this.routeType,
                listAccess: this.accessRoutesList,
                route_index: this.subRouteIndex,
                container: this.parentRouteId,
              });
            }
          }
        }

        // return this.duration.hours() * 60 + this.duration.minutes();
        return minutes;
      },
      sec: function() {
        return this.duration.seconds();
      },
    },

    created() {
      this.duration = moment.duration(this.eventTime.diff(this.currentTime));
    },
  };
</script>

<style></style>
